export default __webpack_public_path__ + "static/char-s-17-en-d780f1c92d158b58b8be1e80f88edbdb.webp";